<template>
      <v-toolbar color="pink sticky-toolbar">
    <v-toolbar-title class="white--text">ＣｏａｃｈｉｎｇＳｐａｃｅ - {{showText}} </v-toolbar-title>
    <v-spacer></v-spacer>

  </v-toolbar>
</template>

<script>
export default {
  data: () => ({
    text: {
      kwestionariuszmojakariera: 'Kwestionariusz "Moja kariera"',
      autotest: 'Zainteresowania i preferencje zawodowe'
    },
    showText: 'asdas'
  }),
  watch: {
    '$route' (to, form) {
      this.showText = this.text[this.$route.name]
    }
  },
  created: function () {
    this.showText = this.text[this.$route.name]
  }
}
</script>

<style>

.sticky-toolbar {
  position: sticky;
  top: 0;
  z-index: 1;
}

</style>
